export default (doc) => {
  if(!doc || !doc.lang) {
    return "/";
  }
  const lang = doc.lang.substring(0, 2);

  if (doc.type === "home") {
    if (lang !== "fr") {
      return `/${doc.lang.substring(0, 2)}`;
    }
    return "/";
  }

  if (doc.type === "services") {
    if (lang === "lu") {
      return `/${lang}/déngschter`;
    }
    if (lang === "en") {
      return `/${lang}/services`;
    }
    return "/services";
  }

  if (doc.type === "team") {
    // if (lang === "fr") {
    //   return `/${lang}/equipe`;
    // }
    if (lang === "en") {
      return `/${lang}/team`;
    }
    if (lang === "lu") {
      return `/${lang}/team`;
    }
    return "/equipe";
  }

  if (doc.type === "about_history") {
    // if (lang === "fr") {
    //   return `/${lang}/a-propos`;
    // }
    if (lang === "en") {
      return `/${lang}/history`;
    }
    if (lang === "lu") {
      return `/${lang}/geschicht`;
    }
    return "/a-propos";
  }

  if (doc.type === "testimonials_home") {
    if (lang === "fr") {
      return `/${doc.lang.substring(0, 2)}/temoignages`;
    }
    return `/${doc.lang.substring(0, 2)}/testimonials`;
  }

  if (doc.type === "articles") {
    if (lang === "lu") {
      return `/${doc.lang.substring(0, 2)}/artikel/${doc.uid}`;
    }
    return `/${doc.lang.substring(0, 2)}/article/${doc.uid}`;
  }

  if (doc.type === "jobs") {
    if (lang === "fr") {
      return `/${doc.lang.substring(0, 2)}/emplois`;
    }
    return `/${doc.lang.substring(0, 2)}/jobs`;
  }

  if (doc.type === "contact") {
    return `/${doc.lang.substring(0, 2)}/contact`;
  }
/*
  if (doc.type === "myfisco") {
    return `/${doc.lang.substring(0, 2)}/myfisco`;
  }
  */

  if (doc.type === "articles_home") {
    if (lang === "lu") {
      return `/${doc.lang.substring(0, 2)}/artikelen`;
    }
    return `/${doc.lang.substring(0, 2)}/articles`;
  }

  return "/";
};
